import React from 'react';
import { governanceAreas } from '../../data/mock';

const GovernanceSection = () => {
  return (
    <section id="governance" className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B1F33] via-[#0F2942] to-[#0B1F33]"></div>
      
      {/* Subtle background image - Data/security */}
      <div className="absolute inset-0 opacity-[0.03]">
        <img 
          src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=2940&auto=format&fit=crop"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      {/* Decorative diagonal line */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: `repeating-linear-gradient(
          45deg,
          transparent,
          transparent 100px,
          rgba(91, 181, 197, 0.5) 100px,
          rgba(91, 181, 197, 0.5) 101px
        )`
      }}></div>

      {/* Decorative glow */}
      <div className="absolute bottom-0 left-1/3 w-96 h-96 bg-[#1F7A8C]/10 rounded-full blur-[150px] pointer-events-none"></div>

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="flex items-center gap-4 mb-4">
          <div className="w-14 h-0.5 bg-[#5BB5C5] rounded"></div>
          <p className="text-[#E8B86D] text-xs font-medium uppercase tracking-widest">Governance & Compliance</p>
        </div>
        <h2 className="text-[#5BB5C5] font-semibold text-2xl lg:text-3xl mb-4 max-w-2xl">
          Governance & Compliance Alignment
        </h2>
        <p className="text-[#B8C8D8] text-lg mb-12 max-w-3xl">
          <span className="text-[#E8B86D]">IJSS IT Solutions</span> takes a governance-first approach to all <span className="text-[#5BB5C5]">SAP MDG</span> engagements. 
          Our delivery methodology supports audit requirements, regulatory compliance, 
          and enterprise control frameworks.
        </p>

        {/* Governance Areas */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {governanceAreas.map((area) => (
            <div key={area.id} className="service-card">
              <h3 className="text-[#E8B86D] font-semibold text-lg mb-3">
                {area.title}
              </h3>
              <p className="text-[#A8B8C8]">
                {area.description}
              </p>
            </div>
          ))}
        </div>

        {/* Compliance Standards */}
        <div className="bg-gradient-to-r from-[#122A40] to-[#1A3A52] p-8 rounded-lg border border-[rgba(91,181,197,0.2)]">
          <h4 className="text-[#5BB5C5] font-semibold mb-6">
            Governance Standards
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              'Full audit trail capability',
              'Segregation of duties support',
              'Change control procedures',
              'Regulatory alignment'
            ].map((standard, index) => (
              <div key={index} className="flex items-center gap-3">
                <span className="w-2 h-2 bg-[#5BB5C5] rounded-full flex-shrink-0"></span>
                <span className="text-[#A8B8C8] text-sm">{standard}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GovernanceSection;
